import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
import { ReceiptCategoriesDistributionChartProps } from "models/propTypes/receiptPropTypes";
import { AppState } from "store";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useReceiptService } from "serviceHooks";
//#endregion
import { useSelector } from "react-redux";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ChartContainerDataSet } from "models/propTypes/chartProps";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const ReceiptCategoriesDistributionChart: React.FC<ReceiptCategoriesDistributionChartProps> = (props) => {
  const receiptService = useReceiptService();
  const { legendType, showTotal } = props;
  const receiptCategories = useSelector((x: AppState) => x.auth.selectedCompany.receiptCategories ?? []);

  const sortedData = (data?: WintSuperkollAPIModel.ReportWidget): ChartContainerDataSet[] => {
    const datasets =
      data?.data?.map((d, index) => ({
        label: data?.dataLabels ? data.dataLabels[index] : "",
        data: d.dataPoints ? d.dataPoints[0] : 0,
      })) ?? [];

    datasets.forEach((item) => {
      const lbl = item.label;
      if (typeof lbl === "string" && lbl.trim().length === 0) {
        item.label = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Uncategorized);
      }
    });

    datasets.sort((a, b) => (Number(b.data ?? 0) || 0) - (Number(a.data ?? 0) || 0));

    if (datasets.length <= 6) return datasets;

    const topFive = datasets.slice(0, 5);
    const rest = datasets.slice(5);
    const othersTotal = rest.reduce((sum, item) => sum + (typeof item.data === "number" ? item.data : 0), 0);

    return [
      ...topFive,
      {
        label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.RemainingValues),
        data: othersTotal,
      },
    ];
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.ReceiptCategoriesDistribution}
      doughnutChartLegendType={legendType ?? ChartEnums.LegendType.WITH_VALUES}
      filterToAPIHandler={receiptService.reportToAPIFilter}
      usePageFilter={false}
      apiToChartHandler={sortedData}
      showTotal={showTotal ?? true}
      useClickableChart
      onDataPointClickedSetFilter={(label?: any) => {
        const clickedLabel = typeof label === "string" ? label : undefined;
        const matchedCategory = receiptCategories.find((c) => (c.name ?? "") === clickedLabel);
        return matchedCategory ? { receiptCategories: [{ id: matchedCategory.id, value: matchedCategory.name }] } : {};
      }}
      onBackgroundClickedSetFilter={{ receiptCategories: [] }}
    />
  );
};

export default ReceiptCategoriesDistributionChart;
